export default __webpack_public_path__ + "static/media/aigo.0513cad5.png";